import type { Contact } from '../../domain/contact';
import type { CollectedDataItem } from '../../domain/message';

import SharedDataExtractionService from './sharedDataExtractionService';

const createSalesforceDataExtractionService = () => {
  const { extractContentByKey, extractCompanyName, extractCompanyDomainFromEmail } = SharedDataExtractionService;

  const extractCompanyDomain = (collectedData: CollectedDataItem[]): string | undefined => {
    return extractContentByKey(collectedData, 'Company Website') as string;
  };

  const extractContactInfo = (collectedData: CollectedDataItem[]): Partial<Contact> => {
    const name = extractContentByKey(collectedData, 'Full Name') as string;
    const email = extractContentByKey(collectedData, 'Contact Email') as string;
    return {
      name,
      site: extractCompanyDomainFromEmail(email),
    };
  };

  const extractLeadInfo = (collectedData: CollectedDataItem[]): Partial<Contact> => {
    const name = extractContentByKey(collectedData, 'Full Name') as string;
    const email = extractContentByKey(collectedData, 'Contact Email') as string;
    return {
      name,
      site: extractCompanyDomainFromEmail(email),
    };
  };

  return { extractCompanyDomain, extractCompanyName, extractContactInfo, extractLeadInfo };
};

const SalesforceDataExtractionService = createSalesforceDataExtractionService();

export default SalesforceDataExtractionService;
